import { render, staticRenderFns } from "./procurement_project_changes_notification.vue?vue&type=template&id=2e325832&scoped=true&"
import script from "./procurement_project_changes_notification.vue?vue&type=script&lang=js&"
export * from "./procurement_project_changes_notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e325832",
  null
  
)

export default component.exports